'use client'
import { usePageTransition } from '@/hooks'
import { getP18 } from '@/styles'
import { usePathname, useSearchParams } from 'next/navigation'
import {  useEffect } from 'react'
import styled from 'styled-components'

export const CortinaControler = () => {
  const { cortinaTransitionName, setCortinaTransitionName, setTransitionName, targetHref, isLoading, setIsLoading } = usePageTransition()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  // const fullPath = `${pathname}?${searchParams.toString()}`

  // 1. When route matches and we're in 'covering', trigger 'revealing'
  useEffect(() => {
    if (!targetHref) return

    const currentPath = pathname
    const currentSearch = searchParams.toString()

    const targetUrl = new URL(targetHref, window.location.origin)

    const isSamePath = targetUrl.pathname === currentPath
    const isSameSearch = targetUrl.search === `?${currentSearch}` || (!targetUrl.search && !currentSearch)

    const shouldReveal = isSamePath && isSameSearch && cortinaTransitionName === 'covering'

    if (shouldReveal) {
      setCortinaTransitionName('revealing')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, searchParams, targetHref, cortinaTransitionName])

  // 2. When 'revealing' happens, trigger 'done' after a delay
  useEffect(() => {
    if (cortinaTransitionName === 'revealing') {
      // console.log('[cortinaTransitionName] revealing')
      const timeout = setTimeout(() => {
        // console.log('[cortinaTransitionName] done')
        setCortinaTransitionName('done')
      }, 500)

      return () => clearTimeout(timeout)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cortinaTransitionName])


  // 3. When done, kick off transition
  useEffect(() => {
    // console.log('[useEffect:cortinaTransitionName]', cortinaTransitionName)
    if (cortinaTransitionName === 'done') {
      // console.log('[cortina done] triggering exit transition')
      setTransitionName('exit')
      setIsLoading(false)
      const timeout = setTimeout(() => {
        // console.log('[transition exit done]')
        setTransitionName(null)
      }, 500)

      return () => clearTimeout(timeout)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cortinaTransitionName])

  // 4. When exiting, reset cortinaTransitionName to 'idle'
  return (
    <>
      <P $isLoading={isLoading}>Loading...</P>
    </>
  )
}


const P = styled.p <{ $isLoading?: boolean }>`
  ${getP18}
  color: rgb(77, 77, 77);
  left: 50%;
  opacity: ${({ $isLoading }) => $isLoading ? 1 : 0};
	pointer-events: none !important;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.5s linear;
	user-select: none !important;
  z-index: 1000000001;

`
